import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_create_billing_contract_line_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { billingContractId: number, billingAggregationStrategyId: number }): Promise<{ reason?: string, billingContractLineId?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingContractId)) {
      $missingRequiredInParams.push('\'billingContractId\'');
    }
    if (isNil($inParams.billingAggregationStrategyId)) {
      $missingRequiredInParams.push('\'billingAggregationStrategyId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

